// extracted by mini-css-extract-plugin
module.exports = {"image__container":"styles_image__container__3F6SA","image__view":"styles_image__view__2HL5K","image":"styles_image__3K2WS","max__image":"styles_max__image__2V-pp"};